export function isPromise(obj: any) {
  return !!obj?.then && typeof obj.then === 'function';
}